import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { applyGeckoCompatClass } from './utils/geckoCompat';
import './App.css';

applyGeckoCompatClass();
import GoogleAnalyticsPageViews from './components/GoogleAnalyticsPageViews';
import MainSite from './routes/MainSite';

const AppPlatform = lazy(() => import('./routes/AppPlatform'));
const ArchiwumZagran = lazy(() => import('./pages/ArchiwumZagran'));

function RouteChunkFallback() {
  return (
    <div
      className="route-chunk-fallback"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Ładowanie…"
    />
  );
}
import {
  APP_SUBDOMAIN,
  getAppSubdomainAbsoluteUrl,
  isAppPlatformPath,
} from './utils/constants';
import { redirectPasswordRecoveryTokensToFormPath } from './utils/passwordRecoveryRoutes';

function App() {
  redirectPasswordRecoveryTokensToFormPath();

  const hostname = window.location.hostname;
  const pathname = window.location.pathname;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

  // Produkcja: subdomena app.* pokazuje panel aplikacji
  const isAppSubdomain =
    hostname === APP_SUBDOMAIN || hostname.startsWith('app.');

  // Marketing (forumkapitalu.pl): /billing, /login itd. → app.forumkapitalu.pl (ten sam UI co localhost)
  if (!isLocalhost && !isAppSubdomain && isAppPlatformPath(pathname)) {
    window.location.replace(getAppSubdomainAbsoluteUrl(pathname));
    return null;
  }

  // Lokalnie `/` = landing (MainSite); panel tylko na wybranych ścieżkach (zgodnych z AppPlatform).
  const isLocalAppRoute = isLocalhost && isAppPlatformPath(pathname);
  const isAppPlatform = isAppSubdomain || isLocalAppRoute;

  return (
    <BrowserRouter>
      <>
        <GoogleAnalyticsPageViews />
        {/* PremiumAmbientBackground pominięty na marketingu (!isAppPlatform) — NewLanding ma własne ambient */}
        <div className="app-shell">
          {isAppPlatform ? (
            <Suspense fallback={<RouteChunkFallback />}>
              <AppPlatform />
            </Suspense>
          ) : (
            <Routes>
              <Route path="/" element={<MainSite />} />
              <Route
                path="/archiwum-zagran"
                element={
                  <Suspense fallback={<RouteChunkFallback />}>
                    <ArchiwumZagran />
                  </Suspense>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          )}
        </div>
      </>
    </BrowserRouter>
  );
}

export default App;
